import { motion } from 'framer-motion';

interface WinnerAnnouncementProps {
  activeAnnouncement: {
    id: string;
    winnerName: string;
    prizeType: string;
  } | null;
}

export function WinnerAnnouncement({ activeAnnouncement }: WinnerAnnouncementProps) {
  if (!activeAnnouncement) return null;

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[60] w-full max-w-sm px-4 pointer-events-none select-none">
      {/* Small slide-in toast notification (non-blocking, pointer-events-none) */}
      <motion.div
        initial={{ y: -60, opacity: 0, scale: 0.9 }}
        animate={{ y: 0, opacity: 1, scale: 1 }}
        exit={{ y: -60, opacity: 0, scale: 0.9 }}
        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        style={{
          boxShadow: '0 10px 25px rgba(124, 58, 237, 0.25), inset 0 0 12px rgba(255, 255, 255, 0.05)',
        }}
        className="glass rounded-2xl py-3 px-5 border border-purple-500/30 text-center flex items-center justify-center space-x-3 bg-slate-950/80 backdrop-blur-md pointer-events-auto"
      >
        <span className="text-xl">🏆</span>
        <div className="text-left flex-1 min-w-0">
          <span className="block text-[8px] font-black uppercase tracking-wider text-amber-400">
            Prize Claimed
          </span>
          <p className="text-[10px] font-semibold text-white truncate">
            <span className="font-extrabold text-purple-300">@{activeAnnouncement.winnerName}</span> won {activeAnnouncement.prizeType}!
          </p>
        </div>
      </motion.div>
    </div>
  );
}
export default WinnerAnnouncement;
